// action - state management
import { REGISTER, LOGIN, LOGOUT, INITIALIZED, RELOAD_PERMISSIONS, UPDATE_PROFILE } from './actions';

// initial state
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  permissions: {}
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action) => {
  let newState;
  
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      newState = {
        ...state,
        user
      };
      break;
    }
    case LOGIN: {
      const { user } = action.payload;
      newState = {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        permissions: user?.permissions || {}
      };
      break;
    }
    case LOGOUT: {
      newState = {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        permissions: {}
      };
      break;
    }
    case INITIALIZED: {
      newState = {
        ...state,
        isInitialized: true
      };
      break;
    }
    case RELOAD_PERMISSIONS: {
      const { permissions } = action.payload;
      newState = {
        ...state,
        permissions: permissions || {},
        user: state.user ? {
          ...state.user,
          permissions: permissions || {}
        } : null
      };
      break;
    }
    case UPDATE_PROFILE: {
      const { user } = action.payload;
      newState = {
        ...state,
        user,
        permissions: user?.permissions || state.permissions || {}
      };
      break;
    }
    default: {
      newState = { ...state };
    }
  }
  
  return newState;
};

export default auth;
